// CANONICAL COPY (GH #7115). src/constants/obligations/obl-consent.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-consent',
  title: 'Verify consent management for consent-based processing',
  description:
    'Where processing is based on consent, confirm that consent is freely given, specific, informed and unambiguous, and that the controller is able to demonstrate that the data subject has consented. Verify that consent records are maintained with timestamp, scope and evidence, that withdrawal of consent is as easy as giving it, and that a clear withdrawal channel is published. Where consent covers children in relation to information society services, verify the age-threshold and parental-authorisation controls required under Article 8.',
  category: 'compliance',
  scfIds: ['SCF-PRV-008'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'any',
  fulfilmentCriteria: [
    {
      type: 'consent-purposes-defined',
      description:
        'Consent purposes are defined in the Consent Register (or no consent-based processing is in use)',
    },
    { type: 'document-published', description: 'Consent management procedure is published' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
